import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true,
            error,
        };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service like AppSignal
        // logErrorToMyService(error, errorInfo);
    }

    render() {
        const { hasError, error } = this.state;

        if (hasError) {
            // You can render any custom fallback UI
            return (
                <div>
                    <Helmet>
                        <title>500 - Novaetus</title>
                    </Helmet>
                    <div id="notfound">
                        <div className="notfound">
                            <div className="notfound-404">
                                <img src="assets/images/logo.png" alt="Novaetus" width={150} />
                            </div>
                            <h2 className="text-white mb-3">500 - Server Error</h2>
                            <p className="text-white">The server encountered an internal error or misconfiguration and was unable to complete your request. "<span className="fw-500 text-danger">{error?.message}</span>"</p>
                            <Link to="/">Return Home</Link>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
